import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoPollbolt from '../logo-pollbolt-main.svg';

const MainNavigation = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Header */}
      <header className="flex justify-between items-center h-14">
        <div className="flex items-center gap-12">
          <button
            onClick={() => navigate('/')}
            className="h-14 w-[100px] flex items-center justify-center group pl-3"
          >
            <img 
              src={LogoPollbolt} 
              alt="PollBolt Logo" 
              className="h-24 cursor-pointer" 
            />
          </button>
          <nav className="hidden sm:flex items-center gap-6 pt-1">

            <button 
              className="text-base font-['Inter'] font-medium text-black hover:text-gray-700 transition-colors py-1.5"
              onClick={() => navigate('/plans')}
            >
              Plans
            </button>
          </nav>
        </div>

        {/* Mobile Menu Button */}
        <div className="sm:hidden">
          <button 
            className="text-black p-1.5"
            onClick={() => setIsMobileMenuOpen(prev => !prev)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Desktop Auth Buttons */}
        <div className="hidden sm:flex items-center gap-3">
          <button 
            className="px-4 sm:px-5 py-1.5 text-sm sm:text-base text-black hover:text-gray-700 transition-colors font-['Inter'] font-medium"
            onClick={() => navigate('/auth')}
          >
            Login
          </button>
          <button 
            className="px-4 sm:px-5 py-3 text-sm sm:text-base rounded-xl bg-[#FFFD63] text-black hover:bg-[#FFFD63]/80 transition-all duration-300 font-['Inter'] group relative overflow-hidden"
            onClick={() => navigate('/auth?mode=signup')}
          >
            <span className="relative z-10 font-semibold">Get Started Free</span>
            <div className="absolute inset-0 bg-gradient-to-r from-[#FFFD63]/80 to-[#FFFD63] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="sm:hidden absolute top-20 left-0 right-0 bg-white z-50 border-b border-gray-200">
          <nav className="flex flex-col p-4">

            <button 
              className="py-3 text-left text-base font-['Inter'] font-medium text-black hover:text-gray-700 transition-colors"
              onClick={() => {
                navigate('/plans');
                setIsMobileMenuOpen(false);
              }}
            >
              Plans
            </button>
            <button 
              className="py-3 text-left text-base font-['Inter'] font-medium text-black hover:text-gray-700 transition-colors"
              onClick={() => {
                navigate('/auth');
                setIsMobileMenuOpen(false);
              }}
            >
              Login
            </button>
            <button 
              className="py-3 text-left text-base font-['Inter'] font-medium text-black hover:text-gray-700 transition-colors bg-[#FFFD63]/10 rounded-xl mt-2"
              onClick={() => {
                navigate('/auth?mode=signup');
                setIsMobileMenuOpen(false);
              }}
            >
              Get Started Free
            </button>
          </nav>
        </div>
      )}
    </>
  );
};

export default MainNavigation; 